import { performPostRequest, performDeleteRequest } from '@atlassian/jira-fetch';
import type { IssueKey } from '@atlassian/jira-shared-types';

import { DEFAULT_ORDER_DIRECTION, DEFAULT_ORDER_FIELD } from './constants';
import type {
	AttachmentId,
	AttachmentsQueryOptions,
	AttachmentsResponse,
	IssueAttachment,
} from './types';

export const initialAttachmentState: IssueAttachment = {
	isDownloading: false,
	isFetching: false,
	error: null,
	totalCount: undefined,
	deletableCount: undefined,
	visibleAttachments: [],
};

export const attachmentsQuery = () => `
  query attachmentsQuery($issueKey: String, $startAt: Long, $maxResults: Long, $orderField: AttachmentsOrderField, $orderDirection: OrderDirection) {
    viewIssue(issueKey: $issueKey) {
        attachments(startAt: $startAt, maxResults: $maxResults, orderField: $orderField, orderDirection: $orderDirection) {
            nodes {
                id
                filename
                mimetype
                mediaApiFileId
                createdDate
                filesize
                parentName
                parentId
                author {
                    accountId
                }
                hasRestrictedParent
            }
            totalCount
            deletableCount
        }
    }
  }`;

const defaultOptions = {
	startAt: 0,
	maxResults: 12,
	orderField: DEFAULT_ORDER_FIELD,
	orderDirection: DEFAULT_ORDER_DIRECTION,
} as const;

export const fetchAttachmentsRequest = async (
	issueKey: IssueKey,
	options?: AttachmentsQueryOptions,
): Promise<AttachmentsResponse | null> => {
	const mergedOptions = {
		...defaultOptions,
		...options,
	};

	const response = await performPostRequest('/rest/gira/1/', {
		body: JSON.stringify({
			query: attachmentsQuery(),
			variables: { issueKey, ...mergedOptions },
		}),
	});

	const attachmentsResponse = response?.data?.viewIssue?.attachments;
	if (
		attachmentsResponse &&
		attachmentsResponse.nodes &&
		attachmentsResponse.totalCount !== undefined
	) {
		return response.data.viewIssue.attachments;
	}
	return null;
};

export const deleteAttachmentRequest = async (attachmentId: AttachmentId) =>
	performDeleteRequest(`/rest/api/2/attachment/${attachmentId}`);
